import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import MarketAnalysisSection from 'legacy/components/MarketAnalysisSection';

import { downloadReportSection } from 'actions/download-report';
import { changeGlossarySelected } from 'actions/support';

import {
  getChartDataMonthsOfSupply,
  getChartDataDaysOnMarket,
  getChartDataMarketIndex,
  getChartDataRiskOfDecline
} from 'selectors/chart-data';
import { getSubjectZipcode, getSubjectAddressId } from 'selectors/subject';
import { getForecastModels, getMarketStats } from 'selectors/report-data';
import { getReportStatusInitialLoadComplete } from 'selectors/report-status';
import { getIsEffectiveDateReport } from 'selectors/property-explorer';
import {
  buildChartConfigMarketIndex,
  buildChartConfigDaysOnMarket,
  buildChartConfigMonthsOfSupply
} from 'legacy/utils/chart-configs';

const mapStateToProps = (state) => {
  const addressId = getSubjectAddressId(state);
  const dataDaysOnMarket = getChartDataDaysOnMarket(state);
  const dataMarketIndex = getChartDataMarketIndex(state);
  const dataMonthsOfSupply = getChartDataMonthsOfSupply(state);
  const isEffectiveDateReport = getIsEffectiveDateReport(state);
  const hasDataDaysOnMarket = dataDaysOnMarket && dataDaysOnMarket.length;
  const hasDataMonthsOfSupply = dataMonthsOfSupply && dataMonthsOfSupply.length;
  let hasDataMarketIndex = false;
  for (let marketType in dataMarketIndex) {
    if (dataMarketIndex[marketType].length) {
      hasDataMarketIndex = true;
      break;
    }
  }
  const chartDataRiskOfDecline = getChartDataRiskOfDecline(state);
  const hasDataRiskOfDecline =
    chartDataRiskOfDecline &&
    !isEmpty(chartDataRiskOfDecline) &&
    chartDataRiskOfDecline.value !== undefined &&
    chartDataRiskOfDecline.value !== null;
  const hasMarketSectionData =
    hasDataDaysOnMarket || hasDataMonthsOfSupply || hasDataMarketIndex;
  return {
    forecastModels: getForecastModels(state),
    marketStats: getMarketStats(state),
    zipcode: getSubjectZipcode(state),
    isReportLoaded: getReportStatusInitialLoadComplete(state),
    chartConfigDaysOnMarket: buildChartConfigDaysOnMarket(
      dataDaysOnMarket,
      addressId
    ),
    chartConfigMonthsOfSupply: buildChartConfigMonthsOfSupply(
      dataMonthsOfSupply,
      addressId
    ),
    chartConfigMarketIndex: buildChartConfigMarketIndex(
      dataMarketIndex,
      addressId
    ),
    chartDataRiskOfDecline,
    hasMarketSectionData,
    hasDataDaysOnMarket,
    hasDataMonthsOfSupply,
    hasDataRiskOfDecline,
    hasDataMarketIndex,
    isEffectiveDateReport
  };
};

const mapDispatchToProps = (dispatch) => ({
  handleClickDownloadSection: () =>
    dispatch(downloadReportSection('marketAnalysis')),
  handleClickInfoButton: (terms) => dispatch(changeGlossarySelected(terms))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MarketAnalysisSection);
